import React from 'react';

import {
  ADD_ACCOUNT_PAGE,
  LOGIN_PAGE_BASE_PATH,
  WORKSPACES_PAGE,
} from 'src/constants';
import { PortalConfigContext } from 'src/context';
import { buildStudioAddAccountPath } from 'src/routes/onboarding/setup/utils/buildStudioAddAccountPath';
import { buildStudioLoginPath } from 'src/routes/onboarding/setup/utils/buildStudioLoginPath';
import { buildStudioSignupPath } from 'src/routes/onboarding/setup/utils/buildStudioSignupPath';

interface WorkspaceMenuPaths {
  /** Where an internal user lands after logging out of the current workspace. */
  internalLogoutRedirectPath: string;
  /** Where the "Create a new workspace" action navigates. */
  createWorkspacePath: string;
  /** Where the "Log in to another workspace" action navigates. */
  addAccountPath: string;
}

/**
 * Studio workspaces have their own passwordless login and prompt-driven signup,
 * so their sidebar menu must route to the Studio auth pages instead of the
 * classic dashboard ones. Portal `isStudioUser` is the source of truth once
 * onboarding has persisted it — the onboarding rollout flag is not required.
 */
export const useWorkspaceMenuPaths = (): WorkspaceMenuPaths => {
  const portalConfig = React.useContext(PortalConfigContext);
  const isStudioWorkspace = Boolean(portalConfig.isStudioUser);

  return {
    internalLogoutRedirectPath: isStudioWorkspace
      ? buildStudioLoginPath()
      : LOGIN_PAGE_BASE_PATH,
    createWorkspacePath: isStudioWorkspace
      ? buildStudioSignupPath()
      : WORKSPACES_PAGE,
    addAccountPath: isStudioWorkspace
      ? buildStudioAddAccountPath()
      : ADD_ACCOUNT_PAGE,
  };
};
